import zipCoordinates from '../data/zipCoordinates.json';

// ZIP centroid lat/long, sourced from the US Census Bureau's public-domain ZCTA
// Gazetteer file, trimmed to the 8 states this platform serves (IL, IN, WI, MI,
// OH, MO, IA, MN) to keep the bundle small. ZIPs outside that set (or malformed
// input) return null -- callers must treat null as "unknown distance", never as
// "too far", since a missing coordinate is not evidence the job/worker is far away.
export function milesBetweenZips(zipA, zipB) {
  const a = zipCoordinates[String(zipA || '').trim().slice(0, 5)];
  const b = zipCoordinates[String(zipB || '').trim().slice(0, 5)];
  if (!a || !b) return null;

  const [lat1, lon1] = a;
  const [lat2, lon2] = b;
  const R = 3958.8; // Earth radius in miles
  const toRad = deg => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const h = Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.asin(Math.sqrt(h));
}
